import { Link, Stack } from '@mui/material';
import { ReadOnlyField as PantryReadOnlyField } from '@side/pantry';
import type { ReactNode } from 'react';

type Props = {
  label: string;
  value?: ReactNode;
  prefix?: ReactNode;
};

const isEmail = (value: ReactNode): value is string => {
  return (
    typeof value === 'string' &&
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
  );
};

export const ReadOnlyField = ({ label, value, prefix }: Props) => {
  const displayValue = isEmail(value) ? (
    <Link href={`mailto:${value}`}>{value}</Link>
  ) : (
    value
  );

  const finalValue =
    prefix && displayValue ? (
      <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
        {prefix}
        {displayValue}
      </Stack>
    ) : (
      displayValue
    );

  return (
    <PantryReadOnlyField
      label={label}
      value={finalValue}
      valueProps={{
        sx: {
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }}
    />
  );
};
